import { createContext, useContext } from 'react';
import type { FunctionDefinition } from '@glueapp/graph-types';

export const FunctionsContext = createContext<FunctionDefinition[]>([]);

export const FunctionsContextProvider = FunctionsContext.Provider;

export function useFunctions() {
    return useContext(FunctionsContext);
}
